module.exports = __webpack_public_path__ + "img/close-icon-modal.9d3d4928.svg";